export default "https://cdn-static.gokick.com/assets/d8950a20925d8040d2b2bc8b449b43040bc9b501/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";